import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d77f5d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-flex tw-flex-col" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-[12px] tw-flex-wrap titleWrapper" }
const _hoisted_3 = { class: "tw-flex-[1]" }
const _hoisted_4 = {
  "data-cy": "multi-level-multi-select-dropdown-item-title",
  class: "tw-text-[#231F20] tw-text-[11px] tw-not-italic tw-font-[500] tw-leading-[normal] title !tw-mb-[0px]"
}
const _hoisted_5 = { class: "tw-text-[#878787] tw-text-[11px] tw-not-italic tw-font-[400] tw-leading-[normal] title !tw-mb-[0px] tw-line-clamp-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z",
    fill: "#387DFF"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "items" }

import { ref, watch } from "vue";
import ToggleIcon from "@/components/svgs/toggleIcon.vue";
import { getComponentUiText } from "@/utils/utilities";
import { DROPDOWN_TYPE } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'mutliLevelMutliSelectDropdownItem',
  props: {
  itemDescription: {
    type: String,
    required: false,
    default: "",
  },
  placeholder: {
    type: String,
    required: false,
    default: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-select-services-1",
    ),
  },
  searchPlaceholder: {
    type: String,
    required: false,
    default: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-services-question-placeholder-1",
    ),
  },
  childData: {
    type: Array,
    required: false,
    default: () => [],
  },
  selected: {
    type: Boolean,
    required: false,
    default: false,
  },
  title: {
    type: String,
    required: false,
    default: "Database",
  },
  level: {
    type: Number,
    required: false,
    default: 0,
  },
  selectedItems: {
    type: Array,
    required: false,
    default: () => [],
  },
  searchValue: {
    type: String,
    required: false,
    default: "",
  },
  isToggle: {
    type: Boolean,
    required: false,
    default: true,
  },
  type: {
    type: String,
    required: false,
    default: DROPDOWN_TYPE.MULTIPLE,
  },
},
  emits: ["update:selected", "update:child-selected"],
  setup(__props, { emit: emits }) {

const props = __props;



const isOpen = ref(false);
const childDataShown: any = ref(props.childData);

const isChildSelected = (id: string) => {
  const childSelected = props.childData.filter((item: any) => item.selected);
  if (props.type === DROPDOWN_TYPE.SINGLE) {
    return props.selectedItems.some((item: any) => item.id === id);
  }
  return childSelected.some((item: any) => item.id === id);
};

watch(
  () => props.childData,
  () => {
    childDataShown.value = props.childData;
  },
);

watch(
  () => props.searchValue,
  () => {
    isOpen.value = true;
    childDataShown.value = props.childData.filter((item: any) =>
      item.title.toLowerCase().includes(props.searchValue.toLowerCase()),
    );
  },
);

return (_ctx: any,_cache: any) => {
  const _component_mutliLevelMutliSelectDropdownItem = _resolveComponent("mutliLevelMutliSelectDropdownItem", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-self-stretch tw-py-[10px] ${
        __props.level === 0 ? 'tw-pl-[24px] tw-pr-[21px]' : 'tw-px-[57px]'
      } ${__props.level === 1 ? 'tw-bg-[#FCFCFD]' : 'tw-bg-[#FFFFFF]'}`),
      onClick: _cache[1] || (_cache[1] = 
        () => {
          if (__props.childData.length > 0) {
            isOpen.value = !isOpen.value;
          } else {
            emits('update:selected', !__props.selected);
          }
        }
      )
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.isToggle)
          ? (_openBlock(), _createBlock(ToggleIcon, {
              key: 0,
              ticked: __props.selected,
              color: "#387DFF",
              class: "tw-cursor-pointer tw-min-w-[20px]",
              onClick: _cache[0] || (_cache[0] = 
            () => {
              if (__props.childData.length > 0) {
                emits('update:selected', !__props.selected);
                isOpen.value = !isOpen.value;
              }
            }
          )
            }, null, 8, ["ticked"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.title), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.itemDescription ? __props.itemDescription : ""), 1)
        ])
      ]),
      (__props.childData.length > 0)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(`arrowIcon ${isOpen.value ? 'rotated' : ''}`)
          }, _hoisted_7, 2))
        : _createCommentVNode("", true)
    ], 2),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childDataShown.value, (child, index) => {
        return (_openBlock(), _createBlock(_component_mutliLevelMutliSelectDropdownItem, {
          key: index,
          "data-cy": "mutliLevelMutliSelectDropdownItem",
          title: child.title,
          "child-data": child.childData,
          selected: isChildSelected(child.id),
          level: 1,
          "onUpdate:selected": 
          () => {
            emits('update:child-selected', child);
          }
        
        }, null, 8, ["title", "child-data", "selected", "onUpdate:selected"]))
      }), 128))
    ], 512), [
      [_vShow, isOpen.value]
    ])
  ]))
}
}

})